import * as yup from "yup";
import React, {Fragment, useEffect, useState} from "react";
import Breadcrumb from "../../../../layout/breadcrumb";
import {Card, CardBody, Col, Container, Form, FormGroup, Nav, Row} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import withReducer from "../../../../store/withReducer";
import productReducer from "../../store";
import PreLoader from "../../../../share-components/ui/preLoader";
import FitModelForm from "./fitModelForm";
import {
    addFitModel,
    closeEditDialog,
    deleteFitModel,
    getAllFitModels,
    openEditDialog,
    openNewDialog,
    selectFitModel,
    updateFitModel
} from "../../store/fitModelSlice";

const dataMenu = [
    {
        type: 0,
        text: 'Products',
        link: '/product'
    },
    {
        type: 1,
        text: 'Product Setting',
        link: ''
    },
    {
        type: 1,
        text: 'Fit Model',
        link: ''
    }
];

const defaultValues = {
    id: '',
    name: '',
    profile_image: null,
    profile_image_url: '',
};

const schema = yup.object().shape({
    name: yup.string().required('You must enter a name'),
    profile_image: yup.mixed().when('id', {
        is: (id) => !id,
        then: (schema) => schema.required('A profile image is required'),
    }),
});

const FitModel = () => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(true);
    const fitModel = useSelector(selectFitModel);
    const [buttonDisable, setButtonDisable] = useState(false);

    useEffect(() => {
        dispatch(getAllFitModels({name})).then(res => {
            if (!res.error) setLoading(false);
        });
    }, [dispatch, name]);

    const tableColumns = [
        {
            name: 'Photo',
            selector: row => row.profile_image_url,
            sortable: false,
            left: true,
            cell: (row) => (
                <img src={row.profile_image_url} alt="" style={{width: 36, height: 36, borderRadius: '50%', objectFit: 'cover'}}/>
            ),
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            left: true,
        },
    ];

    const {handleSubmit, formState, reset, register, setValue, trigger, getValues} = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    const {errors} = formState;

    const onSubmitForm = (dialog, data) => {
        setButtonDisable(true);
        if (dialog.type === 'new') {
            dispatch(addFitModel({...data})).then(res => {
                setButtonDisable(false);
                if (!res.error) closeDialog(dialog.type)
            });
        } else {
            dispatch(updateFitModel({...data})).then(res => {
                setButtonDisable(false);
                if (!res.error) closeDialog(dialog.type);
            });
        }
    }

    const onEdit = (row) => {
        dispatch(openEditDialog(row));
    }

    const onDelete = (row) => {
        dispatch(deleteFitModel(row.id))
    }

    const closeDialog = () => {
        dispatch(closeEditDialog());
    }

    return (
        <Fragment>
            <Container fluid={true} className="product-wrapper">
                {loading ? <><PreLoader></PreLoader></> : <>
                    <Breadcrumb data={dataMenu} title="Fit Model"/>
                    <div className="product-grid">
                        <div className="feature-products">
                            <Row>
                                <Col sm="12">
                                    <Card>
                                        <Row>
                                            <Col sm="6">
                                                <Nav tabs className="border-tab"></Nav>
                                            </Col>
                                            <Col sm="6">
                                                <div className='float-sm-right p-3'>
                                                    <a className="btn btn-sm btn-primary"
                                                       onClick={() => {
                                                           dispatch(openNewDialog())
                                                       }}
                                                    > <i className="fa fa-plus"></i> Add Fit Model</a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col xl="12" sm="12">
                                    <Form>
                                        <FormGroup>
                                            <input onChange={(e) => setName(e.target.value)} name="name"
                                                   type="text" className="form-control"
                                                   placeholder="Search By Name"/>
                                        </FormGroup>
                                    </Form>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <Card>
                                        <CardBody>
                                            <div className="table-responsive product-table mt-4">
                                                <CommonDataTable
                                                    headerColumns={tableColumns}
                                                    gridData={fitModel}
                                                    pagination
                                                    onEdit={onEdit}
                                                    onDelete={onDelete}
                                                />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div> </>
                }
            </Container>
            <ModalFormSubmit
                defaultValues={defaultValues}
                schema={schema}
                onSubmitForm={onSubmitForm}
                reset={reset}
                formState={formState}
                handleSubmit={handleSubmit}
                title='Fit Model'
                selector='product'
                dialog={({product}) => product.fitModel.addDialog}
                closeDialog={closeDialog}
                setValue={setValue}
                getValues={getValues}
                buttonDisable={buttonDisable}
            >
                <FitModelForm
                    errors={errors} register={register} setValue={setValue}
                    trigger={trigger} getValues={getValues}
                />
            </ModalFormSubmit>
        </Fragment>
    );
}

export default withReducer([{product: productReducer}])(FitModel)
